export type HolyWheelSource = "local" | "backend";

/** Shared by Vite's build guard and the runtime; never fall back after an API error. */
export function resolveHolyWheelSource(
    value: string | undefined,
    production: boolean,
): HolyWheelSource {
    const source = value?.trim() || "backend";
    if (source !== "local" && source !== "backend")
        throw new Error("VITE_HOLY_WHEEL_SOURCE must be local or backend.");
    if (production && source === "local")
        throw new Error(
            "Local Holy Wheel is development-only. Set VITE_HOLY_WHEEL_SOURCE=backend for builds.",
        );
    return source;
}
